<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                            <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                                <div class="row align-items-end">
                                    <div class="col-12 col-sm-8 card-header-search-box">
                                        <div class="input-group">
                                            <input class="form-control search-input" type="text"
                                                   :placeholder="$t('main.search')" v-model="filter.search"
                                                   @keypress.enter="initList">
                                            <div class="input-group-append">
                                                <button class="all-btn search-btn" @click="initList">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div  v-if="hasPermission('SETTINGS_AUTO_MANUFACTURE_ADD')" class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                                <router-link tag="button" class="all-btn m-0" :to="add">
                                    <i class="fa fa-plus"></i>{{$t("action.add")}}
                                </router-link>
                            </div>

                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{{$t("common.name")}}</th>
                                    <th class="text-center">
                                        {{$t("realEstate.field.action")}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id">
                                    <td>{{result.id}}</td>
                                    <td><span>{{result.name}}</span></td>
                                    <td class="text-center">
                                        <div class="badge badge-info" v-if="result.status">
                                            {{$t("common.active")}}
                                        </div>
                                        <div class="badge badge-danger" v-else>{{$t("common.deactive")}}</div>
                                    </td>
                                    <td v-if="hasPermission('SETTINGS_AUTO_MANUFACTURE_ADD')" class="td-actions text-center">
                                        <router-link :to="'/auto-manufacture/edit/' + result.id"
                                                     v-tooltip="$t('director.titleEdit')"
                                                     class="all-btn edit-btn table-action">
                                            <i class="fa fa-edit"></i>
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';

    export default {
        name: "AutoManufacture",
        components: {
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        computed: {
            add() {
                return '/auto-manufacture/add';
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('/auto-manufacture/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('directorChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>
